// Shared display helpers for drug/allergy names, used by ADRModal and PatientBanner.
//
// Drug names can carry a leading "(generic name)" prefix (from the search-matched full_name
// format) followed by the actual brand/drug name - only the real drug name word should be
// shown inline in compact UI (e.g. allergy badges), while the full name is kept available for
// a hover tooltip.

// Strips a leading "(generic)" prefix if present and returns the first remaining word.
export function firstDrugWord(text) {
    if (!text) return null;
    const stripped = text.trim().replace(/^\([^)]*\)\s*[–—-]?\s*/, '');
    const source = stripped || text.trim();
    return source.split(/\s+/)[0];
}

// Builds a { short, full } display pair for an ADR/allergy entry's drug: `short` is the first
// word of the drug name (optionally uppercased), `full` is the complete name for a hover
// tooltip. `fallback` is used verbatim (for both short and full) when no drug name is present
// at all - an ADR entry can be recorded against a custom med name, a linked drug alias, or (as
// a last resort) a plain `drug` string field.
export function getDrugDisplayName(item, { fallback = '-', uppercase = false } = {}) {
    const full = item?.custom || (item?.alias && item.alias.name) || item?.drug || null;
    if (!full) return { short: fallback, full: fallback };
    const short = firstDrugWord(full);
    return { short: uppercase ? short.toUpperCase() : short, full };
}
